import React, { useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { FaGoogle } from "react-icons/fa";
import "./logingoogle.css";
import { useAuth } from "../../hooks/useAuth";

const LoginGoogle = ({ onAuthComplete }) => {
  const { googleLoginWithCode } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleCodeSuccess = async ({ code }) => {
    setError("");
    setLoading(true);
    try {
      const data = await googleLoginWithCode(code);

      if (data?.success) {
        onAuthComplete?.({
          success: true,
          email: data.user?.email,
          isNewUser: false,
          user: data.user,
          status: data.meta?.approvalStatus,
          message: data.message || "Logged in with Google",
        });
        return;
      }

      if (data?.isNewUser) {
        onAuthComplete?.({
          success: true,
          email: data.user?.email,
          isNewUser: true,
          user: data.user,
          status: data.meta?.approvalStatus,
          message: data.message || "Your account is awaiting admin approval.",
        });
        return;
      }

      if (!data?.isNewUser) {
        onAuthComplete?.({
          success: true,
          email: data.user?.email,
          isNewUser: false,
          user: data.user,
          status: data.meta?.approvalStatus,
          message: data.message || "Your account is awaiting admin approval.",
        });
        return;
      }

      const msg = data?.message || "Google authentication failed";
      setError(msg);
      onAuthComplete?.({ success: false, error: msg });
    } catch (e) {
      const msg = e?.message || "Google authentication failed";
      setError(msg);
      onAuthComplete?.({ success: false, error: msg });
    } finally {
      setLoading(false);
    }
  };

  // Handle user cancel or popup close
  const handleGoogleError = (err) => {
    const errorType = err?.error;

    if (errorType === "popup_closed_by_user" || errorType === "access_denied") {
      // USER CANCELLED
      const msg = "Google login was cancelled by the user.";
      setError(msg);
      onAuthComplete?.({
        success: false,
        cancelled: true,
        error: msg,
      });
      return;
    }

    // OTHER ERRORS
    const msg = "Google authentication failed.";
    setError(msg);
    onAuthComplete?.({
      success: false,
      error: msg,
    });
  };

  // Initialize Google popup with AUTH-CODE flow
  const loginWithGoogle = useGoogleLogin({
    flow: "auth-code",
    scope: "openid email profile",
    ux_mode: "popup",
    onSuccess: handleCodeSuccess,
    onError: handleGoogleError,
  });

  return (
    <div className="w-full flex justify-end">
      <button
        onClick={loginWithGoogle}
        disabled={loading}
        className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#d9d9d9] cursor-pointer"
      >
        <FaGoogle fill="#787878" size={20} />
      </button>
    </div>
  );
};

export default LoginGoogle;
